<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="tw-w-full lg:tw-max-w-4xl tw-mx-auto" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <fieldset
                class="tw-grid-cols-1  lg:tw-grid-cols-2"
                v-if="formStep === 1"
                key="1"
            >
                <validation-provider class="tw-w-full tw-w-block tw-relative" name="age" rules="required" v-slot="{ classes, errors }" :custom-messages="{ required: ' obrigatória' }">
                    <legend>1 - Qual é a sua idade?</legend>
                    <div class="input-group input-group-age" :class="classes">
                        <input type="tel"
                            id="input-age"
                            placeholder=" "
                            v-model="age"
                            v-mask="{mask: '9[9][9]', placeholder:'_'}"
                        >
                        <label>
                            Idade {{ errors [0]}}
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block tw-relative" name="ears" rules="required" v-slot="{ classes }">
                    <legend>2 - Tem dificuldade em seguir as conversas em ambientes ruidosos?</legend>
                    <div class="input-group input-group-ears" :class="classes">
                        <select id="input-ears" v-model="ears">
                            <option  value="sim">Sim</option>
                            <option  value="nao">Não</option>

                        </select>
                        <label :class="{ 'select-placeholder' : !ears }">
                            Escolher opção
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block tw-relative" name="zip" rules="required|zip:pt" v-slot="{ classes, errors }" :custom-messages="{ required: ' obrigatório', zip: 'inválido' }">
                    <legend>3 - Qual é o seu código postal?</legend>
                    <div class="input-group input-group-zip" :class="classes">
                        <input type="tel"
                            id="input-zip"
                            placeholder=" "
                            v-model="zip"
                            v-mask="{mask: '9999-999', placeholder:'_'}"
                        >
                        <label>
                            Código postal {{ errors [0]}}
                        </label>
                    </div>
                </validation-provider>
                <div class="tw-text-center lg:tw-col-span-2 tw-mt-6 lg:tw-mt-10">
                    <button
                        type="submit"
                        class="btn-cta-fb"
                        id="submit"
                        :disabled="formLoading"
                    >
                        seguinte
                        <svg xmlns="http://www.w3.org/2000/svg" width="7.433" height="13" viewBox="0 0 7.433 13">
                            <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down" d="M6.5,5.192,11.418.273a.925.925,0,0,1,1.312,0,.937.937,0,0,1,0,1.316L7.16,7.162a.927.927,0,0,1-1.281.027L.271,1.593A.929.929,0,0,1,1.583.277Z" transform="translate(0 13) rotate(-90)" fill="#fff"/>
                        </svg>
                    </button>
                </div>
            </fieldset>
            <fieldset
                class="tw-grid-cols-1  lg:tw-grid-cols-2"
                v-if="formStep === 2"
                key="2"
            >
                <p>Preencha o formulário abaixo para entrarmos em contacto consigo:</p>
                <validation-provider class="tw-w-full tw-w-block" name="fullName" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-fb-name" :class="classes">
                        <input type="text"
                            id="input-fullName"
                            placeholder=" "
                            v-model="fullName"
                        >
                        <label>
                            O seu nome
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: ' - inválido' }">
                    <div class="input-group input-group-fb-email" :class="classes">
                        <input type="email"
                            id="input-email"
                            placeholder=" "
                            v-model.lazy="email"
                        >
                        <label>
                            O seu email {{ errors [0]}}
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:pt" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', phone: ' - inválido' }">
                    <div class="input-group input-group-fb-phone" :class="classes">
                        <input type="tel"
                            id="input-phone"
                            placeholder=" "
                            v-model="phone"
                            v-mask="{mask: '999999999', placeholder:' '}"
                        >
                        <label>
                            O seu nº telefone {{ errors [0]}}
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block lg:tw-col-span-3" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                    <div class="mb-2">
                        <div class="form-check p-0">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                <span class="checkmark"></span>
                                <span  class="tw-text-xxs">Autorizo a {{ company }} a utilizar os meus dados para ser contactado segundo a sua <a href="https://www.minisom.pt/politica-de-privacidade" target="_blank"><u>política de privacidade</u></a>.</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block lg:tw-col-span-3" :rules="{required : { allowFalse: true } }" v-slot="{ classes }">
                    <div class="mb-2">
                        <div class="form-check p-0">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="marketing">
                                <span class="checkmark"></span>
                                <span  class="tw-text-xxs">Desejo receber informação e ofertas – marketing direto - da Minisom (Amplifon Portugal, S.A.)</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>
                <div class="tw-text-center lg:tw-col-span-2">
                    <button
                        type="submit"
                        class="btn-cta-fb"
                        id="submit"
                        :disabled="formLoading"
                    >
                        Enviar
                        <svg xmlns="http://www.w3.org/2000/svg" width="7.433" height="13" viewBox="0 0 7.433 13">
                            <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down" d="M6.5,5.192,11.418.273a.925.925,0,0,1,1.312,0,.937.937,0,0,1,0,1.316L7.16,7.162a.927.927,0,0,1-1.281.027L.271,1.593A.929.929,0,0,1,1.583.277Z" transform="translate(0 13) rotate(-90)" fill="#fff"/>
                        </svg>
                    </button>
                </div>
            </fieldset>
            <div class="steps tw-mx-auto tw-flex tw-items-center tw-gap-2 tw-justify-center tw-w-fit tw-mt-8">
                <div :class="{ 'active' : formStep >= 1 }"></div>
                <div :class="{ 'active' : formStep === 2 }"></div>
            </div>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';
import '@/validations/zip';

export default {
    name: 'FormFB',
    data() {
        return {
            formStep: 1,
            age: this.$route.query.age || '',
            ears: this.$route.query.ears || '',
            zip: this.$route.query.zip || '',
            fullName: this.$route.query.fullName || '',
            phone: this.$route.query.phone || '',
            email: this.$route.query.email || '',
            page: '30dias.minisom.aparelho.pt/fb',
            marketing: false,
            siteid: this.$route.query.siteid || '',

            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    methods: {
        formSubmit() {
            this.formLoading = true;
            if (this.formStep < 2) {
                this.formStep += 1;
                this.formLoading = false;
                return;
            }

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,

                age: this.age,
                ears: this.ears,
                zip: this.zip,
                fullName: this.fullName,
                phone: this.phone,
                email: this.email,
                page: this.page,
                marketing: this.marketing,
                siteid: this.siteid,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                    gtag('event', 'conversion', { send_to: 'AW-986637511/K6oWCP2z9qEBEMfJu9YD' });
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'já registado';
                    }
                    if (error.response.data.errors.phone) {
                        error.response.data.errors.phone = 'já registado';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/partials/_variables.scss";
@import "~@/assets/scss/partials/_buttons.scss";

fieldset {

    legend {
        @apply tw-text-left tw-font-bold tw-text-white;
        font-size: 13px;
        line-height: 20px;

        @screen lg {
            @apply tw-text-base;
            line-height: 22px;
        }
    }

    >p {
        @apply tw-font-bold tw-text-base tw-text-white;
        line-height: 22px;
        margin-bottom: 25px;
    }
}

.steps {

    >div {
        @apply tw-rounded-full;
        width: 16px;
        height: 16px;
        background-color: rgba(#ffffff, .2);

        &.active {
            background-color: #ffffff;;
        }
    }
}
</style>
